import React, { useEffect } from 'react';

import { isOrgFeatureEnabled, useSpot } from 'framework';
import { Tabs } from 'components';

import { FileBrowser } from './file-browser';
import { ProfileOverview } from './profile-overview';
import { LeaveConfiguration } from './leave-configuration';
import { HourConfiguration } from './hour-configuration';
import { Onboarding } from './onboarding';
import { Applications } from './applications';

type Tab =
  | 'profile'
  | 'applications'
  | 'onboarding'
  | 'files'
  | 'hourConfig'
  | 'leaveConfig';

interface Props {
  id: string;
  organization: string;
  tab?: string;
  onTabChange?: (tab: string) => void;
  disabledTabs?: Tab[];
}

export const UserInfo = ({
  id,
  organization,
  tab,
  onTabChange,
  disabledTabs
}: Props) => {
  const { data, loading, query } = useSpot();
  const org = data?.organizations?.[organization];

  useEffect(() => {
    if (!org) {
      query(`org/${organization}`, {}, ['organizations', organization]);
    }
  }, [org, organization, query]);

  const tabs: { [k: string]: JSX.Element } = {
    profile: <ProfileOverview id={id} organization={organization} />,
    applications: <Applications id={id} organization={organization} />,
    onboarding: <Onboarding id={id} organization={organization} />,
    files: <FileBrowser organization={organization} id={id} />,
    leaveConfig: <LeaveConfiguration organization={organization} id={id} />,
    hourConfig: <HourConfiguration organization={organization} id={id} />
  };

  if (!isOrgFeatureEnabled(org, 'apps')) {
    delete tabs.applications;
  }

  if (!isOrgFeatureEnabled(org, 'leave')) {
    delete tabs.leaveConfig;
  }

  // eslint-disable-next-line no-unused-expressions
  disabledTabs?.forEach(tb => delete tabs[tb]);

  return (
    <>
      <Tabs
        tabs={tabs}
        selected={tab}
        onTabChange={onTabChange}
        loading={loading}
      />
    </>
  );
};
